import "@aws-amplify/ui-react/styles.css";
import { 
  Box, 
  Heading,
  Stack,
  Center,
  Image,
  Text 
} from '@chakra-ui/react'
import React from "react";



let datadump = {};
async function LoadData() {
  // const API_NAME = 'photos';
  // const PATH = '/site-data'; 
  // const result = await API.get(API_NAME, PATH, {});
  // console.log("site-data response: " + JSON.stringify(result));
  // datadump = result;
  return {};
}

const loadDataCall = LoadData();

class DebugPage extends React.Component<any, any> {
    componentDidMount() {
      const compThis = this;
      async function waitOnData() {
        await loadDataCall;
        compThis.setState({
            data: datadump,
        });
      };
      waitOnData();
    }

    render() {

      let datastring = "NO DATA";
      if (this.state?.data) {
        datastring = JSON.stringify(this.state.data);
      }

      return (<>
      <Box alignItems="center" justifyContent="space-between" mb={20}>
        <Heading textAlign='center' mt={10} mb={10}>Page Not Found</Heading>
        <Center>
          <Stack alignContent='center' justifyContent='center'>
            <Center>
              <Image boxSize='192px' src="/logotransp192.png" />
            </Center>
            <Text>{datastring}</Text>
          </Stack>
        </Center>
      </Box>
    </>
    )
  }
}

export default DebugPage;